module.exports = __webpack_public_path__ + "media/images/img_opportunity03-6bf102c0ca5e0d589564f752df6e1776.png";